import React from 'react'
import { REPORTS_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { Report } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import ReportContainer from '../containers/Reports/Report/Reports.container';
import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const Reports = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case REPORTS_TYPE.REPORT:
                return 'Reportes'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case REPORTS_TYPE.REPORT:
                return 'Reportes'    
        }
    };

    const ReportsBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {REPORTS_TYPE[type] !== REPORTS_TYPE['REPORTS-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [REPORTS_TYPE.REPORT]: ReportContainer
    }
    const ComponentToRender = typeToComponentMap[type];
    console.log(typeToComponentMap[type]);
    

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.reports} />} />}
                header={<Heading title={TypeTitle(type)} icon={<Report size={50} />} breadcrumbs={<ReportsBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default Reports